namespace TabAurous.Administration {
    export interface ItemDiscountDetailsRow {
        DetailsId?: number;
        Id?: number;
        Code?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        MaxDiscount?: number;
        String1?: string;
    }

    export namespace ItemDiscountDetailsRow {
        export const idProperty = 'DetailsId';
        export const nameProperty = 'String1';
        export const localTextPrefix = 'Administration.ItemDiscountDetails';
        export const lookupKey = 'Administration.ItemDiscountDetails';

        export function getLookup(): Q.Lookup<ItemDiscountDetailsRow> {
            return Q.getLookup<ItemDiscountDetailsRow>('Administration.ItemDiscountDetails');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = '*';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            DetailsId = "DetailsId",
            Id = "Id",
            Code = "Code",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            MaxDiscount = "MaxDiscount",
            String1 = "String1"
        }
    }
}
